module.exports = __webpack_public_path__ + "media/images/icon__settings-07e04a623c17a00fb2ad6306108a4d06.png";